import { ADD_MULTIPLEMODEL_LIST_DETAILS, ADD_MULTIPLEMODEL_LIST_DETAILS_ERROR, ADD_MULTIPLEMODEL_LIST_DETAILS_SUCCESS, DATA_GENERATIONTYPE, DATA_GENERATIONTYPE_ERROR, DATA_GENERATIONTYPE_SUCCESS, DELETE_MULTIPLEMODEL_LIST_DETAILS, DELETE_MULTIPLEMODEL_LIST_DETAILS_ERROR, DELETE_MULTIPLEMODEL_LIST_DETAILS_SUCCESS, DETECTIONALG_LIST, DETECTIONALG_LIST_ERROR, DETECTIONALG_LIST_SUCCESS, MODEL_CLASSIFICATIONS, MODEL_CLASSIFICATIONS_ERROR, MODEL_CLASSIFICATIONS_SUCCESS, MODELTYPE_LIST, MODELTYPE_LIST_ERROR, MODELTYPE_LIST_SUCCESS, MULTIPLEMODEL_LIST, MULTIPLEMODEL_LIST_DETAILS, MULTIPLEMODEL_LIST_DETAILS_ERROR, MULTIPLEMODEL_LIST_DETAILS_SUCCESS, MULTIPLEMODEL_LIST_ERROR, MULTIPLEMODEL_LIST_SUCCESS, UPDATE_MULTIPLEMODEL_LIST_DETAILS, UPDATE_MULTIPLEMODEL_LIST_DETAILS_ERROR, UPDATE_MULTIPLEMODEL_LIST_DETAILS_SUCCESS } from './constants';

export default function multimodelReducer(state, action) {
	let multimod = [];
	let modelClassificationDate = [];
	let datagentype = [];
	let modeltype = [];
	let detalg = [];
	
	switch (action.type) {
	case MULTIPLEMODEL_LIST:
		return { ...state, pending: true };
      
	case MULTIPLEMODEL_LIST_SUCCESS:
        
		if (action.payload && action?.payload?.data?.length > 0) {
			
			action?.payload?.data?.map( (item) => {
				let data = {};
				data.id = item.id ? item.id : 0;
				data.pipelineId = item.pipelineId ? item.pipelineId : null;
				data.name = item && item?.name && item?.name ? item.name : '';
				data.channelinfoId = item.channelinfoId ? item.channelinfoId : null;
				data.channelname = item?.channelinfo && item?.channelinfo?.name ? item?.channelinfo?.name : '';  
				data.datagenerationtypeId = item.datagenerationtypeId ? item.datagenerationtypeId : '';
				data.modeltypeId = item.modeltypeId ? item.modeltypeId : null;
				data.modelPath = item.modelPath ? item.modelPath : '';
				data.wellalgorithmId = item.wellalgorithmId ? item.wellalgorithmId : null;
				data.confidenceThreshold = item.confidenceThreshold ? item.confidenceThreshold : 0;
				data.curlEnabled = item.curlEnabled ? item.curlEnabled : null;
				data.status = item.status ? item.status : null;
				data.pidsinfoId = item && item?.pidsinfoId && item?.pidsinfoId ? item.pidsinfoId : null;
				data.createdAt = item.createdAt ? item.createdAt : '';
				data.updatedAt = item.updatedAt ? item.updatedAt : '';
				data.modelclassificationId = item.modelclassificationId ? item.modelclassificationId : null;
				data.pidsname = item?.pidsinfo?.name ? item?.pidsinfo?.name : null;
				data.channelname = item.channelinfo.name ? item.channelinfo.name : '';
				data.modeltypeName = item.modeltype && item?.modeltype?.name ? item?.modeltype?.name : '_' ;
				data.datagenName = item.datagenerationtype && item?.datagenerationtype?.name ? item?.datagenerationtype?.name : '' ;
				data.modelclassname =  item &&  item?.modelclassifications?.alias ? item.modelclassifications?.alias : item.modelclassifications?.modelLevel ? item.modelclassifications?.modelLevel : '-';
				data.pidsinfoId = item.pidsinfoId ? item.pidsinfoId : null;
				data.modelclassdescription = item && item &&  item?.modelclassifications?.description ? item.modelclassifications?.description : 'Nill';
				data.isSubChain = item.isSubChain ? item.isSubChain : false;
				data.mainClass = item && item?.mainClass ? item.mainClass : '';
				data.curlPath  = item && item?.curlPath ? item.curlPath : '';
				data.pickleFilePath = item && item?.pickleFilePath ? item.pickleFilePath : '_'; 
				data.modelClass  = item && item?.modelconfiguration && item?.modelconfiguration?.eventTypes ? item?.modelconfiguration?.eventTypes : [];
				data.detectionalgname =  item.detectionalgorithmtype && item?.detectionalgorithmtype?.name ? item?.detectionalgorithmtype?.name : '_' ;
				data.modelPrediction = item.modelPrediction ?? true;
				data.detectionalgorithmtypeId = item.detectionalgorithmtypeId ?  item.detectionalgorithmtypeId : null;
				return multimod.push(data);
			});
          
			return { ...state, multimod: multimod, pending: false, error: false };
		} else {
			if (action.payload && action.payload.data.length === 0) {
				return { ...state, multimod: [], pending: false, error: false };
			} else {
				return { ...state, pending: false, error: true };
			}
		}
      
	case MULTIPLEMODEL_LIST_ERROR:
		return { ...state, pending: false, error: true };

	case MULTIPLEMODEL_LIST_DETAILS:
		return { ...state, pending: true };

	case MULTIPLEMODEL_LIST_DETAILS_SUCCESS:
		return { ...state, details: action.payload, pending: false, error: false };

	case MULTIPLEMODEL_LIST_DETAILS_ERROR:
		return { ...state, pending: false, error: true };

	case ADD_MULTIPLEMODEL_LIST_DETAILS:
		return { ...state, pending: false };

	case ADD_MULTIPLEMODEL_LIST_DETAILS_SUCCESS:
		return { ...state, pending: false, error: false };

	case ADD_MULTIPLEMODEL_LIST_DETAILS_ERROR:
		return { ...state, pending: false, error: true };

	case UPDATE_MULTIPLEMODEL_LIST_DETAILS:
		return { ...state, pending: false };

	case UPDATE_MULTIPLEMODEL_LIST_DETAILS_SUCCESS:
		return { ...state, pending: false, error: false };

	case UPDATE_MULTIPLEMODEL_LIST_DETAILS_ERROR:
		return { ...state, pending: false, error: true };
      
	case DELETE_MULTIPLEMODEL_LIST_DETAILS:
		return { ...state, pending: false };

	case DELETE_MULTIPLEMODEL_LIST_DETAILS_SUCCESS:
		return { ...state, pending: false, error: false };

	case DELETE_MULTIPLEMODEL_LIST_DETAILS_ERROR:
		return { ...state, pending: false, error: true };
   
	case MODEL_CLASSIFICATIONS:
		return { ...state, loading: true, error: false };
						
	case MODEL_CLASSIFICATIONS_SUCCESS:
		if(action?.payload?.data){
			action.payload.data && action.payload.data.map((item) => {
					
				modelClassificationDate.push({
					id : item.id,
					// modelLevel : item.modelLevel,
					// parentmodelLevel : item.parentmodelLevel,
					// isSynced : item.isSynced,
					alias : item &&  item?.alias ? item?.alias : item?.modelLevel ? item?.modelLevel : '-',
					// description : item?.description ? item.description : ''
				});
					
			});
		}	
			
	
		return { ...state, loading: false, modelClassificationDate : modelClassificationDate , error: false };
						
	case MODEL_CLASSIFICATIONS_ERROR:
		return { ...state, loading: false, error: true };
	
	case DATA_GENERATIONTYPE:
		return { ...state, loading: true, error: false };
						
	case DATA_GENERATIONTYPE_SUCCESS:
		if(action?.payload?.data){
			action.payload.data && action.payload.data.map((item) => {
					
				datagentype.push({
					id : item && item.id ?item.id : null,
					name : item && item.name ? item.name : '',
				});
					
			});
		}	
			
	
		return { ...state, loading: false, datagentype : datagentype , error: false };
						
	case DATA_GENERATIONTYPE_ERROR:
		return { ...state, loading: false, error: true };
	case MODELTYPE_LIST:
		return { ...state, loading : true, error : false};
	
	case MODELTYPE_LIST_SUCCESS:
		if(action?.payload.data){
			action?.payload?.data?.map((item) => {
				modeltype.push({
					id : item && item?.id ? item.id : null,
					name : item && item?.name ? item.name : '',
				});
			});
		}
	
		return {...state, modeltype : modeltype,  loading : false, error : false};
	
	case MODELTYPE_LIST_ERROR:
		return { ...state, modeltype : [], loading : false, error : true};

	case DETECTIONALG_LIST:
		return { ...state, loading : true, error : false};
	
	case DETECTIONALG_LIST_SUCCESS:
		if(action?.payload.data){
			action?.payload?.data?.map((item) => {
				detalg.push({
					id : item && item?.id ? item.id : null,
					name : item && item?.name ? item.name : '',
				});
			});
		}
	
		return {...state, detalg : detalg,  loading : false, error : false};
	
	case DETECTIONALG_LIST_ERROR:
		return { ...state, detalg : [], loading : false, error : true};
	
	
	
	
	default: {
		throw Error('Unknown action: ' + action.type);
	}
	}
}